import React from "react";
import { useI18n } from "@/i18n";
import { Users, Briefcase, Wifi, Droplet, Camera, MessageCircle } from "lucide-react";

const MAIN_PHOTO =
  "https://customer-assets.emergentagent.com/job_gallura-auto-rental/artifacts/vfttlow5_1782508931419.jpg.jpg";

const WHATSAPP_NUMBER = "393470011246";

export default function CarSection() {
  const { lang, t } = useI18n();
  const features = [
    { icon: Users, label: t.car.f1 },
    { icon: Briefcase, label: t.car.f2 },
    { icon: Wifi, label: t.car.f3 },
    { icon: Droplet, label: t.car.f4 },
  ];
  const waText = encodeURIComponent(
    lang === "it"
      ? "Ciao! Posso vedere altre foto dell'auto?"
      : "Hi! Can I see more photos of the car?"
  );
  return (
    <section
      id="car"
      data-testid="car-section"
      className="py-24 lg:py-32 bg-[#F9F7F3] grainy"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_80px_rgba(10,36,99,0.15)]">
            <img
              src={MAIN_PHOTO}
              alt="Chrysler 300C Touring blu sulla costa della Gallura"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] accent-text" data-testid="car-eyebrow">
            {t.car.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl brand-text mt-4 leading-tight">
            {t.car.title}
          </h2>
          <p className="text-base md:text-lg text-slate-600 mt-6 max-w-xl">{t.car.desc}</p>

          <div className="grid grid-cols-2 gap-4 mt-10">
            {features.map((f) => (
              <div
                key={f.label}
                className="flex items-center gap-3 p-4 rounded-xl bg-white border border-slate-200/70 shadow-[0_4px_20px_rgba(0,0,0,0.03)]"
              >
                <div className="w-10 h-10 rounded-full brand-bg text-white grid place-items-center">
                  <f.icon className="w-5 h-5" />
                </div>
                <span className="text-sm text-slate-700">{f.label}</span>
              </div>
            ))}
          </div>

          {/* Photo CTA — invites customers to ask for more pictures */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${waText}`}
            target="_blank"
            rel="noreferrer"
            data-testid="car-photos-cta"
            className="mt-8 flex items-center gap-4 p-5 rounded-xl bg-white border border-dashed border-slate-300 hover:border-[#0A2463] transition-colors group"
          >
            <div className="w-11 h-11 rounded-full bg-[#F9F7F3] grid place-items-center brand-text">
              <Camera className="w-5 h-5" />
            </div>
            <div className="flex-1">
              <div className="font-medium brand-text">{t.car.more_photos_title}</div>
              <div className="text-xs text-slate-500 mt-0.5">{t.car.more_photos_hint}</div>
            </div>
            <div className="w-9 h-9 rounded-full bg-[#25D366] grid place-items-center text-white group-hover:scale-105 transition-transform">
              <MessageCircle className="w-4 h-4" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
